import moment from 'moment';

const timestampToHrsMin = (timeString?: string | null, format?:any) => moment.parseZone(timeString).format(format);

export default timestampToHrsMin;
